import { alfredItemTypeMap } from "@@/shared/sections/alfred-item-type";
import type { Except } from "type-fest";
import { z } from "zod";
import {
    type OptionalGroupId,
    optionalGroupIdZodSchema,
} from "../optionals/optional-group-id";
import { type OptionalId, optionalIdZodSchema } from "../optionals/optional-id";
import {
    type ReservationCommon,
    reservationCommonFactory,
    reservationCommonZodSchema,
} from "./reservation-common";

type ReservationOptional = ReservationCommon & {
    readonly itemType: typeof alfredItemTypeMap.OPTIONAL;
    readonly optionalGroupId?: OptionalGroupId;
    readonly optionalId: OptionalId;
    readonly quantity: number;
};

const reservationOptionalFactory = (params: {
    optionalGroupId?: OptionalGroupId;
    optionalId: OptionalId;
    quantity: number;
    timeOutInMinutes?: number;
}): ReservationOptional => {
    const reservationOptional: ReservationOptional = {
        ...reservationCommonFactory(params.timeOutInMinutes),
        ...params,
        itemType: alfredItemTypeMap.OPTIONAL,
    };
    return reservationOptional;
};

const partialReservationOptionalZodSchema: z.ZodSchema<
    Except<ReservationOptional, keyof ReservationCommon>
> = z.object({
    itemType: z.literal(alfredItemTypeMap.OPTIONAL),
    quantity: z.number().min(1).int(),
    optionalId: optionalIdZodSchema,
    optionalGroupId: optionalGroupIdZodSchema,
});
const reservationOptionalZodSchema = reservationCommonZodSchema.and(
    partialReservationOptionalZodSchema,
);

export { reservationOptionalFactory, reservationOptionalZodSchema };
export type { ReservationOptional };
